<template>
  <div>
    <!-- Selector para añadir producto -->
    <div class="d-flex gap-2 mb-3 align-items-center flex-wrap">
      <select v-model="productoSeleccionado" class="form-select form-select-sm" style="max-width: 320px">
        <option value="">— Añadir producto —</option>
        <option
          v-for="p in productosDisponiblesFiltrados"
          :key="p.id"
          :value="p"
        >
          {{ p.nombre }} — {{ formatPrecio(p.precio) }}
        </option>
      </select>
      <button type="button" class="btn btn-sm btn-primary mb-0" :disabled="!productoSeleccionado" @click="agregarProducto">
        Añadir
      </button>
    </div>

    <!-- Lista de productos asignados -->
    <div v-if="modelValue.length === 0" class="text-sm text-muted">
      Sin productos asignados.
    </div>

    <table v-else class="table table-borderless table-listado">
      <thead class="thead-light">
        <tr>
          <th class="sin-orden">Producto</th>
          <th class="sin-orden" style="width: 90px">Precio</th>
          <th class="sin-orden" style="width: 80px">Orden</th>
          <th class="sin-orden" style="width: 100px">Destacado</th>
          <th class="sin-orden" style="width: 60px"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in modelValue" :key="item.producto_id">
          <td class="align-middle text-sm">{{ item.nombre }}</td>
          <td class="align-middle text-sm">{{ formatPrecio(item.precio) }}</td>
          <td class="align-middle">
            <input
              type="number"
              min="0"
              class="form-control form-control-sm"
              style="width: 70px"
              :value="item.orden"
              @change="actualizarOrden(idx, $event.target.value)"
            />
          </td>
          <td class="align-middle text-center">
            <input type="checkbox" :checked="item.destacado" @change="actualizarDestacado(idx, $event.target.checked)" />
          </td>
          <td class="align-middle text-center">
            <i class="fas fa-trash text-secondary" style="cursor:pointer" @click="quitarProducto(idx)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "PasarelaProductosSelector",
  props: {
    modelValue: { type: Array, default: () => [] },
    productosDisponibles: { type: Array, default: () => [] },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      productoSeleccionado: "",
    };
  },
  computed: {
    productosDisponiblesFiltrados() {
      const asignados = new Set(this.modelValue.map((p) => p.producto_id));
      return this.productosDisponibles.filter((p) => !asignados.has(p.id));
    },
  },
  methods: {
    agregarProducto() {
      if (!this.productoSeleccionado) return;
      const lista = [...this.modelValue];
      lista.push({
        producto_id: this.productoSeleccionado.id,
        nombre: this.productoSeleccionado.nombre,
        precio: this.productoSeleccionado.precio,
        orden: lista.length,
        activo: true,
        destacado: false,
      });
      this.$emit("update:modelValue", lista);
      this.productoSeleccionado = "";
    },
    quitarProducto(idx) {
      const lista = this.modelValue.filter((_, i) => i !== idx);
      this.$emit("update:modelValue", lista);
    },
    actualizarOrden(idx, valor) {
      const lista = this.modelValue.map((item, i) =>
        i === idx ? { ...item, orden: parseInt(valor) || 0 } : item
      );
      this.$emit("update:modelValue", lista);
    },
    actualizarDestacado(idx, valor) {
      const lista = this.modelValue.map((item, i) =>
        i === idx ? { ...item, destacado: valor } : item
      );
      this.$emit("update:modelValue", lista);
    },
    formatPrecio(precio) {
      return Number(precio).toFixed(2).replace(".", ",") + " €";
    },
  },
};
</script>

<style scoped>
select.form-select,
select.form-control {
  background-image: none !important;
  -webkit-appearance: menulist !important;
  -moz-appearance: menulist !important;
  appearance: menulist !important;
  padding-right: 0.75rem !important;
}
table td,
table th {
  border: none !important;
  border-radius: 0 !important;
}
table th::after {
  display: none !important;
  content: none !important;
  width: 0 !important;
  height: 0 !important;
}
table thead th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
}
table tbody tr:not(:last-child) td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
}
</style>
